'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
function itemType(item) {
  if (item.type === 'link' || item.page_id || item.navigation_section_id) {
    return 'Link';
  }
  return 'Section';
}

exports.default = itemType;


//////////////////
// WEBPACK FOOTER
// ./~/cadmus-navbar-admin/lib/itemType.js
// module id = 139
// module chunks = 0